import React, { useEffect, useState }  from "react";
import { Link, useLocation } from "react-router-dom";
import PrivacyModal from "./PrivacyModal";
import SitemapModal from "./SitemapModal";

function Footer(props) {

	const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isSitemapOpen, setIsSitemapOpen] = useState(false);

	const [isVisible, setIsVisible] = useState(false);
	//const [bottom, setBottom] = useState(40); // 기본 위치
	const location = useLocation();
	
	// AI 페이지인지 확인하는 함수
	const isAiPage = () => {
		return location.pathname.startsWith('/WIS');
	};

	/*useEffect(() => {
    // 현재 페이지가 adminLogin 경우 스크롤 이벤트를 실행하지 않음
    if (window.location.pathname === '/adminLogin') return;
    
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // 버튼 표시 여부
      setIsVisible(scrollY > 100);

      // 푸터 위치 확인
      const footer = document.querySelector(".footer");
      
      if(!footer) return; // footer가 없으면 함수 종료
      if (footer) {
        const footerRect = footer.getBoundingClientRect();

        if (footerRect.top < windowHeight) {
          // 푸터가 보이기 시작하면 버튼 위로 이동
          setBottom(footerRect.height + 10);
        } else {
          setBottom(40);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  */
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  //파일다운로드
		const downloadFile = async () => {
			const response = await fetch("/download/brochure");
			const blob = await response.blob();
		
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = "위피아_AI솔루션.pdf";
			a.click();
			a.remove();
			window.URL.revokeObjectURL(url);
		};


    return (
        <>
          <footer className="footer">
						<div className="footerMenu">
								<ul className="container-auto">
									<li><a className="bold"  onClick={() => setIsPrivacyOpen(true)}>개인정보보호방침</a></li>
									<li><a onClick={() => setIsSitemapOpen(true)}>사이트맵</a></li>
									<li><Link to="/locationInfo">Contact Us</Link></li>
									{/* <li><Link to="/adminLogin">Admin</Link></li> */}
								</ul>
						</div>
						<div className="container-auto footer-text">
							<address>
								<ul className="address">
									<li>서울특별시 영등포구 경인로 775, 1-507(문래동3가, 에이스하이테크시티)</li>
									<li>대표번호 : 02-2038-8311</li>
									<li>팩스번호 : 02-2038-8322</li>
								</ul>
							</address>
							<p className="copyright">COPYRIGHT ⓒ 2025 WIPIA CO., LTD. ALL RIGHTS RESERVED.</p>
              <p className="img-sources"><a href="http://www.freepik.com">Designed by macrovector / Freepik</a></p>

						</div>
					</footer>

					{/* 모달 */}
					<PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
      		<SitemapModal isOpen={isSitemapOpen} onClose={() => setIsSitemapOpen(false)} />


          {/* 퀵메뉴 버튼 */}
					{/* <button  className={`top-button ${isVisible ? "active" : ""}`} style={{ bottom: `${bottom}px` }}onClick={scrollToTop}>TOP</button> */}
          <div className="quick-menu">
            {/* <Link className="inquiry-btn" to="/Inquiry"><span>제품 문의하기</span></Link> */}
            {isAiPage() ? (
              <Link className="inquiry-btn" to="/Inquiry"><div className="rotate"><span>제품 문의하기</span></div></Link>
              // <button className="inquiry-btn" onClick={downloadFile}><div className="rotate"><span>브로슈어 다운로드</span></div></button>
            ) : (
              <Link className="aiSol-btn" to="/WISbot"><div className="rotate"><span>AI 솔루션 바로가기</span></div></Link>
            )}
					  <button  className={`top-button`} onClick={scrollToTop}>TOP</button>
          </div>
          
        </>
    );
}

export default Footer;